import { createRoot } from "react-dom/client";
import { env } from "@/config/env";
import { Maintenance } from "@/pages/Maintenance";
import { App } from "./App";
import { initSentry, sentryErrorHandlers } from "@/services/sentry";
import "@/styles/global.css";

const applyEnvTheme = () => {
	document.documentElement.dataset.theme = env.mode;
};

applyEnvTheme();

const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("Root element not found");
}
if (env.MAINTENANCE_MODE) {
	createRoot(rootElement).render(<Maintenance />);
} else {
	initSentry();

	createRoot(rootElement, sentryErrorHandlers).render(<App />);
}
